import * as MD from '@material-ui/core';
import * as React from 'react';
import { I18N } from '../../Store/I18n/Types';

import { Dispatch } from 'redux';
import { IApplicationState } from '../../Store';
import { connect } from 'react-redux';

import { IExportState, IExportType } from '../../Store/Export/Types';
import { cleanFile } from '../../Store/Export/Actions';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

import { IElectionsState } from '../../Store/Elections/Types';
import { Dialog } from '../Dialog';

const styles = (theme:any) => MD.createStyles({
    closeButton: {
        position: 'absolute',
        right: '0px',
        top: '4px',
        color: theme.palette.grey[500],
      },
      
  formControl: {
    width: '100%',
    position:'absolute'
  },
  searchButton: {
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingTop: '5px',
    paddingBottom: '5px',
    cursor:'pointer',
  },
  containerDivText:{
    textAlign:'center',
    display:'flex',
    justifyContent:'center',
    marginTop:'20px', 
    marginBottom:'20px', 
    fontSize:'16px'
  },
})

interface IState {
    open: boolean;
    file: any;
}
interface IPropsFromDispatch {
    cleanFile: typeof cleanFile;
}
interface IPropsFromState {
    i18n: I18N;
    file: IExportState;
    filters: any;
    elections: IElectionsState;
}
interface IOwnProps {
    exportType: IExportType;
    title?:string;
    exportAction: (filters: any) => void;
}

type ExportAllProps = 
    MD.WithTheme &
    MD.WithStyles<typeof styles> &
    IPropsFromState &
    IPropsFromDispatch &
    IOwnProps;

export class ExportComponent extends React.Component<ExportAllProps, IState> {
    public constructor(props: ExportAllProps) {
        super(props);

        this.state = {
            open: false,
            file: null
        }
    }
  public componentDidMount() {
  }

  public render() {
    const { exportType, file, i18n } = this.props;
    const downloadType = (exportType: IExportType) => {
        switch (exportType) {
            case 'csv':
                return 'ExportDashboard.csv'
            case 'xml':
                return 'ExportDashboard.zip'
            default:
                return true
        }
    }
    
    return (
        <React.Fragment>
          <MD.Button type="button" href="#" className={this.props.classes.searchButton} 
              color='secondary'
              onClick={this.handleClickOpen.bind(this,exportType)} 
              variant='contained'
              startIcon={<CloudDownloadIcon />}
              style={{marginRight: 10}}>
              <span style={{fontSize:'small'}}>
                    { this.props.title === undefined ?  `Export ${exportType}`.toUpperCase() : this.props.title}
              </span>
          </MD.Button>
          <Dialog 
          closeDialog={this.handleClose.bind(this)} 
          open={this.state.open} 
          title={ this.props.title === undefined ?  `Export ${exportType}`.toUpperCase() : this.props.title}
          width={'220px'}
          content={
            file.file === null ? 
            <MD.Typography gutterBottom className={this.props.classes.containerDivText}>
                  {i18n._('Loading')}...
            </MD.Typography>
          :
            <MD.Typography gutterBottom className={this.props.classes.containerDivText}>
              <a style={{color: 'inherit'}} href={file.file} download={downloadType(exportType)}>
                {i18n._('Click to download')}
              </a>
            </MD.Typography>
          }
          />
        </React.Fragment>
    );
  }

  private handleClickOpen = (exportType: IExportType) => {
    const { filters } = this.props;
    this.props.exportAction(filters)
    this.setState({open: true});
  }

  private handleClose = () => {
      this.props.cleanFile();
    this.setState({open: false});
  }
}

const mapStateToProps = ({ i18n, file, elections }: IApplicationState) => ({
  i18n: i18n.i18n,
  file,
  elections
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  cleanFile: () => dispatch(cleanFile()),
});

export const Export = connect(mapStateToProps, mapDispatchToProps)
                (MD.withTheme(MD.withStyles(styles)(ExportComponent)));
